
export default class JourneyTelemetryExtended {
    constructor (
        extendedRoute,
        startGap,
        endGap,
        id,
        hardwareId,
        utc,
        previousJourneyTelemetryMetadata,
        startPoint,
        endPoint,
        lengthMeters,
        timeInSeconds,
        idleTimeInSeconds,
        maxSpeed,
        rootObject,
        exceptions,
        blobs,
        idlePoints,
        endOfJourneyIdlePoint,
        noGpsEvents,
        noCarSignalEvents,
        noTelemetryEvents,
        timeToLive,
        reprocessingDate,
        noGps,
        organizationId,
        fleetId,
        vehicleId,
        driverId
    ) {
        this.extendedRoute = extendedRoute
        this.startGap = startGap
        this.endGap = endGap
        this.id = id
        this.hardwareId = hardwareId
        this.utc = utc
        this.previousJourneyTelemetryMetadata = previousJourneyTelemetryMetadata
        this.startPoint = startPoint
        this.endPoint = endPoint
        this.lengthMeters = lengthMeters
        this.timeInSeconds = timeInSeconds
        this.idleTimeInSeconds = idleTimeInSeconds
        this.maxSpeed = maxSpeed
        this.rootObject = rootObject
        this.exceptions = exceptions
        this.blobs = blobs
        this.idlePoints = idlePoints
        this.endOfJourneyIdlePoint = endOfJourneyIdlePoint
        this.noGpsEvents = noGpsEvents
        this.noCarSignalEvents = noCarSignalEvents
        this.noTelemetryEvents = noTelemetryEvents
        this.timeToLive = timeToLive
        this.reprocessingDate = reprocessingDate
        this.noGps = noGps
        this.organizationId = organizationId
        this.fleetId = fleetId
        this.vehicleId = vehicleId
        this.driverId = driverId
    }
}
